import type {
  AdapterProps,
  CheckCodeAuthResponse,
  CheckCodeDataToBackend,
  NewPasswordDataToBackend,
  RegistrationDataToBackend,
} from './types';

import { URL } from '../../constants';
import { httpApiService } from '../../utils/create-http-api-service';
import { defaultRequestService } from '../../utils/default-request-service';

export const getCheckCode = (
  requestData: RegistrationDataToBackend,
  config: AxiosRequestConfig,
) => {
  return defaultRequestService<AdapterProps<typeof requestData>>(
    URL.REGISTRATION_CHECK_PHONE,
    httpApiService.post,
    {
      requestData,
      requestConfig: config,
    });
};

export const sendCheckCode = (requestData: CheckCodeDataToBackend) => {
  return defaultRequestService <
  AdapterProps<typeof requestData>, void, { type: string }
  >(URL.REGISTRATION_CHECK_CODE, httpApiService.post, {
    requestData,
  });
};

export const sendNewPassword = (requestData: NewPasswordDataToBackend) => {
  return defaultRequestService<AdapterProps<typeof requestData>>(
    URL.REGISTRATION_SET_PASSWORD, httpApiService.post, {
      requestData,
    });
};

export const sendCheckCodeAuth = (requestData: CheckCodeDataToBackend) => {
  return defaultRequestService <
  AdapterProps<typeof requestData>,
   CheckCodeAuthResponse,
   { type: string; host: string; key: string }
  >(URL.AUTHENTICATION_CHECK_CODE, httpApiService.post, {
    requestData,
  });
};
